import React, { useState } from 'react';
import { getMeds } from 'store/storeValtio';
import * as mh from 'helpers/medicationHelpers';
import { getTransactionsFromDb } from 'store/localDb';

export default function SaveDataTest() {
const [error, setError] = useState('No error');
  const meds = getMeds();
  console.log('SaveDataTest');

  let medsData = 'Medication List\n\n';
  meds.forEach((m, ix) => {
    if (!m.isPaused) {
      medsData += m.name +'\n'
      medsData += '  FORM:     ' + m.form + ',\n'
      medsData += '  STRENGTH: ' + m.strength + ',\n'
      medsData += '  DOSAGE:   ' + mh.formatDosage(m) + ',\n'
      medsData += '\n'
    }
  });

  async function handleTrans() {
    const trans = await getTransactionsFromDb();
    console.log('trans', trans);
  }

  // console.log('medsData', medsData);

  const saveFile = async (blob, suggestedName) => {
    // Feature detection. The API needs to be supported
    // and the app not run in an iframe.
		setError('saveFile: ' + suggestedName);
    const supportsFileSystemAccess =
      'showSaveFilePicker' in window &&
      (() => {
        try {
          return window.self === window.top;
        } catch(err) {
					console.log('showSaveFilePicker window err', err);
					setError('showSaveFilePicker window err' + err);
          return false;
        }
      })();
    // If the File System Access API is supported…
    if (supportsFileSystemAccess) {
      try {
        // Show the file save dialog.
        const handle = await window.showSaveFilePicker({
          suggestedName,
        })
				.catch((err) => {
					console.log('showSaveFilePicker errr', err);
					setError('showSaveFilePicker errr' + err);
				});
        console.log('savefile handle: ', handle);
        // Write the blob to the file.
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        console.log('file written ??');
        setError('file written ??');
        return;
      } catch (err) {
        // Fail silently if the user has simply canceled the dialog.
        setError('Trap: ' + err);
        if (err.name !== 'AbortError') {
          console.error(err.name, err.message);
          return;
        }
      }
    }

    // Fallback if the File System Access API is not supported…
		setError('supportsFileSystemAccess is FALSE - saving to DOWNLOAD folder');
		saveToDownload(blob);
  };

  async function getFile() {
    let fileHandle;
    // open file picker
    [fileHandle] = await window.showOpenFilePicker();
  
    if (fileHandle.kind === "file") {
      // run file code
      console.log('fileHandle file: ', fileHandle);
      const data = await fileHandle.getFile();
      console.log('data: ', data);
    } else if (fileHandle.kind === "directory") {
      // run directory code
      console.log('fileHandle dir: ', fileHandle);
    } else {
        console.log('fileHandle other: ', fileHandle);
    }
  }

  async function handleExport() {
    //exportData(medsData);
    //getFile();
    saveFile(medsData, 'savefiledata.txt');
}

  function saveToDownload(data) {
		try {
			const link = document.createElement("a");
			const savedata = `data:text/json;chatset=utf-8,${data}`;
			//const file = new Blob([data], { type: "text/plain;charset=utf-8" });
			//const url = URL.createObjectURL(file);
			link.href = savedata;
			link.download = "medication_list.txt";
			link.click();
			setError('saved to DOWNLOAD folder');
		} catch(err) {
			setError('error saving to DOWNLOAD folder: ' + err);
		}

  };

  return (
    <div className='w-full h-full pt-10 flex flex-col justify-center items-center'>
        {error && (
        <div className = 'w-60 p-2 bg-red-300 rounded-md'>
            {error}
        </div>
        )}
        <div className = 'mt-10'>
            <button 
            className='rawBtn w-60 h-20 bg-blue-400'
            onClick={()=>handleExport()}
            >
                Save Data Test
            </button>
        </div>
        <div className = 'mt-10'>
            <button 
            className='rawBtn w-60 h-20 bg-blue-400'
            onClick={()=>handleTrans()}
            >
                Get All Transactions
            </button>
        </div>
    </div>
  );
}
